(function () {
  if (window.innerWidth >= 750) return;

  const sectionElement = document.currentScript.closest('section');
  if (!sectionElement) return;

  const reviewsLinks = sectionElement.querySelectorAll('a[href="#judgeme_product_reviews"]');
  if (!reviewsLinks.length) return;

  reviewsLinks.forEach(function (linkElement) {
    linkElement.addEventListener('click', function (clickEvent) {
      const targetElement = document.querySelector('#judgeme_product_reviews .jm-action-buttons');
      if (!targetElement) return;

      clickEvent.preventDefault();

      const stickyHeaderElement = document.querySelector('.shopify-section-group-header-group.reverse-counter__wrapper');
      const stickyHeaderRect = stickyHeaderElement ? stickyHeaderElement.getBoundingClientRect() : null;
      const stickyHeaderHeight = (stickyHeaderRect && stickyHeaderRect.top <= 0) ? stickyHeaderElement.offsetHeight : 0;

      const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 100 - stickyHeaderHeight;

      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    });
  });
})();